import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FontIcon from 'react-toolbox/lib/font_icon';
import TextColor from 'common/components/core/colors/text.scss';
import BackgroundColor from 'common/components/core/colors/background.scss';
import pure from 'recompose/pure';
import Tooltip from 'common/components/core/tooltip';
import PlaceholderLoader from 'common/components/core/loader/PlaceholderLoader';

@pure
class MlFontIcon extends Component {
    static defaultProps = {
        theme: {}
    };
    render() {
        const {
            iconClass,
            theme,
            color,
            className,
            numberLabel,
            style,
            bgColor,
            loading, // eslint-disable-line no-unused-vars
            ...others
        } = this.props;
        var iconClassName = classnames({
            'ml-icon': iconClass,
            [iconClass]: iconClass,
            [theme.numberLabel]: !iconClass,
            [TextColor[color]]: color,
            [BackgroundColor[bgColor]]: bgColor,
            [className]: className
        });
        return iconClass ? (
            <FontIcon style={style} className={iconClassName} {...others}>
                {numberLabel ? numberLabel : null}
            </FontIcon>
        ) : (
            <span
                data-toolbox="font-icon"
                className={iconClassName}
                style={style}
                {...others}
            >
                {numberLabel}
            </span>
        );
    }
}

MlFontIcon.propTypes = {
    icon: PropTypes.string
};
const TooltipMlFontIcon = Tooltip(MlFontIcon);
const TooltipMlFontIconLoader = PlaceholderLoader(TooltipMlFontIcon);

export { MlFontIcon, TooltipMlFontIconLoader };
export default MlFontIcon;
